import glass from './glass'

function findGlasgoot(name) {
    return glass.find(glass => glass.name === name).glasgoot || '?'
}

export default function VentilationOrder(data, corrections) {

    let width= data.width;
    let type = data.type;
    let glassType = data.glass;
    let number = data.number;
    let ventilation = data.ventilation;
    let position = data.position;
    let comment = data.commentsVentilation;

    if(type === '1')
        this.width = width-corrections.glass_width_correction;
    else if(type==='2')
        this.width = width-corrections.glass_width_correction_window;

    this.description = ventilation + " " + this.width + "mm  glasgoot " + findGlasgoot(glassType) + "mm";
    if(position)
        this.description += " Pos: " + position;

    if(comment)
        this.description += "   Opmerking: " + comment;

    this.number = number;

}



// WEBPACK FOOTER //
// ./src/data/VentilationOrder.js